import React, { FC } from 'react';

import { IconProps } from 'types/components';

const CardIcon: FC<IconProps> = ({
  xmlns = 'http://www.w3.org/2000/svg',
  viewBox = '0 0 210 136',
  width = '1.55em',
  height = '1em',
  ...props
}) => (
  <svg
    xmlns={xmlns}
    viewBox={viewBox}
    width={width}
    height={height}
    {...props}
  />
);

export default CardIcon;
